import Search from '../../components/Search';
import Inventory from '../../entities/Inventory';
import createTradeIn from '../../api/createTradeIn';
import getSearchService from '../../services/SearchService';

interface SearchContainerPropsInterface {
  applyUrl: string;
}

export default function SearchContainer(props: SearchContainerPropsInterface) {
  const { applyUrl } = props;
  const searcher = getSearchService();

  const handleSearch = (term: string) => searcher.search(term);

  const handleSelectInventory = async (inventory: Inventory) => {
    await createTradeIn(inventory);
    window.location.href = applyUrl;
  };

  return (
    <Search
      onSearch={handleSearch}
      onSelectInventory={handleSelectInventory}
    />
  );
}
